import { render, staticRenderFns } from "./TopQueryList.vue?vue&type=template&id=19b2b9c0&scoped=true"
import script from "./TopQueryList.vue?vue&type=script&lang=js"
export * from "./TopQueryList.vue?vue&type=script&lang=js"
import style0 from "./TopQueryList.vue?vue&type=style&index=0&id=19b2b9c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2b9c0",
  null
  
)

export default component.exports